import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpRequestsService } from 'src/app/services/http-requests.service';

@Component({
  selector: 'app-lab-city-actions',
  templateUrl: './lab-city-actions.component.html',
  styleUrls: ['./lab-city-actions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LabCityActionsComponent implements OnInit {

  public city = history.state.city;
  public expanded: boolean;
  public data: any = [];
  public actions: any = [];
  public description: any;

  constructor(private req: HttpRequestsService<any>) { }

  ngOnInit(): void {
    this.req.getCityEvaluationActions(this.city).subscribe((res) => {
      this.data = res;
      this.data.forEach(element => {
        element.expanded = false;
      })
    });
  }

  onClick(category) {
    this.data.forEach(element => {
      if (element.Action_Cat == category) {
        element.expanded = !element.expanded;
      }
      else {
        element.expanded = false;
        this.actions = [];
      }
    })
    for (let i = 0; i < this.data.length; i++) {
      this.actions.push(this.data[i].Actions);
    }
  }

  onActionMouseover(action) {
    this.req.getCityActionEvaluationDescription(this.city, action).subscribe((res) => {
      const originalHTML = res[0].Description;
      this.description = originalHTML.replace(/<[^>]*>/g, '');
    });
  }

}
